import { FETCH, CREATE, DELETE, UPDATE, FULFILLED } from 'actionTypes';
import { fork, takeEvery, takeLatest } from 'redux-saga/effects';
import pluralize from 'utils/pluralize';
import { create, fetch, fetchPaginated, remove, update } from 'utils/sagasHelpers';

// `scopedByAccount` says this entity's rows belong to a customer, which is a fact
// about the entity and so is declared once, here, beside its url. Everything
// downstream is then automatic: the collection fetch reads the account out of
// `state.auth` and names it in the URL, and no caller anywhere - the boot, a
// screen refetching after a save, code written next year - has to know or
// remember. Default false, because the six reference tables are answered the
// same way for everybody and naming an account would keep twenty-two identical
// copies of one list.
export default (ENTITY, url, { scopedByAccount = false } = {}) => {
  const PLURAL = pluralize(ENTITY);

  function* watchCreate() {
    yield takeLatest(CREATE + ENTITY, create(CREATE + ENTITY, url));
  }

  function* watchDelete() {
    yield takeLatest(DELETE + ENTITY, remove(DELETE + ENTITY, url));
  }

  function* watchFetchAll() {
    yield takeLatest(FETCH + PLURAL, fetchPaginated(FETCH + PLURAL, url, scopedByAccount));
  }

  function* watchFetchOne() {
    yield takeEvery(FETCH + ENTITY, fetch(FETCH + ENTITY, url));
  }

  function* watchUpdate() {
    yield takeLatest(UPDATE + ENTITY, update(UPDATE + ENTITY, url));
  }

  return [
    fork(watchCreate),
    fork(watchDelete),
    fork(watchFetchAll),
    fork(watchFetchOne),
    fork(watchUpdate)
  ];
};
